<template>
  <div id="app">
    <keep-alive :include="$store.state.nav.routes">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 人工客服 -->
    <div
      v-if="moduleConfig.M_HUMAN_CAR && mobile && isCheckRoute"
      ref="contact"
      class="contact"
      :class="showAvatar ? '' : 'contact_active'"
    >
      <div class="contact_info">
        <div
          class="contactAvart"
          :class="showAvatar ? '' : 'active'"
          @click.stop="moveAvatar"
        >
          <Svga
            :svga-img="call"
            :width="200"
            :height="200"
            elid="1"
            class="svga"
          ></Svga>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Svga from '@/components/Svga/index.vue'
import call from '@/assets/online.svga?url'
export default {
  name: 'App',
  components: {
    Svga,
  },
  data() {
    return {
      isHide: true,
      call,
      showAvatar: true,
      scorllTime: null,
    }
  },
  computed: {
    isCheckRoute() {
      let ishide = true
      switch (this.$route.path) {
        case '/online':
          ishide = false
          break
      }
      return ishide
    },
    mobile() {
      return this.$store.state.base.isTestJT
    },
    moduleConfig() {
      return this.$store.state.base.moduleConfig
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      // console.log(clientHeight)
      setTimeout(() => {
        if (window.scrollY > 0) {
          this.showAvatar = false
          clearTimeout(this.scorllTime)
        } else {
          this.showAvatar = true
        }
        this.scorllTime = setTimeout(() => {
          this.showAvatar = true
        }, 3000)
      }, 20)
    })
  },
  methods: {
    moveAvatar() {
      this.$router.push('/online')
    },
  },
}
</script>
<style scoped lang="scss">
.contact {
  position: fixed;
  right: 50px;
  top: 70%;
  .contact_info {
    display: flex;
    padding: 20px 0;
    align-items: center;
    .contactAvart {
      width: 116px;
      .svga {
        position: relative;
      }
    }
    .active {
      opacity: 0.5;
    }
  }
}
.contact_active {
  right: 0px;
}
</style>
